import ZkTabs from './src/tabs';

/* istanbul ignore next */
ZkTabs.install = function(Vue) {
  Vue.component(ZkTabs.name, ZkTabs);
};

export default ZkTabs;



// WEBPACK FOOTER //
// ./src/packages/tabs/index.js